if (!customElements.get('featured-product')) {
  customElements.define(
    'featured-product',
    class FeaturedProduct extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initializeSwiper();
      }

      initializeSwiper() {
        if (this.swiper) return;

        this.swiper = new Swiper('.featured-product-slider', {
          slidesPerView: 1.1,
          spaceBetween: 16,
          pagination: {
            el: '.featured-product-slider-pagination',
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          },
        });
      }
    }
  );
}
